// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3hh-x","title":"FrontImage_title__EW5_p"};